import React from "react";

const PageInvalidUrl = () => (
  <div className="text-center">
    <p className="h1">Ogiltig URL</p>
  </div>
);

export default PageInvalidUrl;
